export const head = {
  head: {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M21 15.535v2c0 .4-.1.8-.4 1.1-.3.3-.7.4-1.1.4H19v-6c0-1-.2-1.9-.5-2.7 0-.1-.1-.2-.1-.3.1.9.1 2.3-1 1.5-1.1-.8-2-3.6-2-3.6-1 1.3-5.5 2.1-7.6 2.5-.8.1-1.5-.2-2-.7-.1.2-.2.3-.2.5-.4.9-.6 1.8-.6 2.7v6h-.5c-.4 0-.8-.2-1.1-.4-.3-.3-.4-.6-.4-1v-2c0-.3.1-.5.3-.8.2-.2.4-.5.7-.6v-1.3c0-1.1.3-2.1.7-3 .1-.3.3-.6.5-.9-.1-.2-.1-.4-.1-.6v-.7c0-1.2 2-1.6 2.8-1.7.1 0 .1-.1 0-.1-1.3-.4-1.6-1.1-1.6-1.1s2-2 7.4.6c.1.1.2.1.4.2 0 0 .1 0 .1-.1-.1-.2-.2-.5.1-.6.3-.2.5.4.6.6 0 .1.1.1.2 0 .3-.3.9-1 .7-.3-.2.6-.4.7-.5.8.5.2.9.5 1.3.8l.7.7c.7.7 1.3 1.5 1.7 2.5.4.9.7 2 .7 3v1.3c.3.2.5.4.7.6.5.1.6.4.6.7Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
